<button href="javascript:void(0);" class={{classButton}} id="js-bootbox-alert-1" (click)="onClick()" [innerHTML]="nameButton" [disabled]="disabled"></button>
